PageVue
  template(v-slot:body)
    ForgotCodeVue(v-if='forgotCodeStep' @email-filled='e => askResetPassword(e.value)')
    ResetPasswordVue(v-else :email='email')
